module.exports = __webpack_public_path__ + "img/img-99b966.png";